import { useEffect } from "react";
import { useLocale } from "../lib/i18n";

interface InstallBannerProps {
  show: boolean;
  isIOS: boolean;
  streak?: number;
  onInstall: () => void;
  onDismiss: () => void;
  onAutoHide: () => void;
}

export function InstallBanner({ show, isIOS, streak, onInstall, onDismiss, onAutoHide }: InstallBannerProps) {
  const { t } = useLocale();

  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(onAutoHide, 10000);
    return () => clearTimeout(timer);
  }, [show, onAutoHide]);

  if (!show) return null;

  const message = streak && streak >= 3
    ? t("install.streak", { count: streak })
    : t("install.default");

  return (
    <div className="fixed bottom-20 left-3 right-3 z-50 mx-auto max-w-[420px] bg-zinc-800/95 backdrop-blur rounded-xl px-4 py-3 shadow-lg animate-slide-up">
      <div className="flex items-center gap-3">
        <img src="/icons/icon-192x192.png" alt="ניגונים" className="w-10 h-10 rounded-lg flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-semibold truncate">{message}</p>
        </div>
        {isIOS ? (
          <p className="text-xs text-zinc-400 flex-shrink-0">
            Tap <span className="text-white">Share</span> then <span className="text-white">Add to Home Screen</span>
          </p>
        ) : (
          <button
            onClick={onInstall}
            className="bg-indigo-500 text-white text-sm font-semibold px-4 py-2 rounded-lg flex-shrink-0"
          >
            {t("install.button")}
          </button>
        )}
      </div>
      <button onClick={onDismiss} className="absolute top-1 end-2 text-zinc-500 text-lg leading-none">&times;</button>
    </div>
  );
}
